/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import LoadingScreen from "src/components/LoadingScreen";

const routesConfig = [
  // {
  //   exact: true,
  //   path: "/product/:id/:brand?/:title?",
  //   component: lazy(() => import("./views/Product")),
  // },
  // {
  //   exact: true,
  //   path: "/shipping",
  //   component: lazy(() => import("./views/CheckoutShipping")),
  // },
  // {
  //   exact: true,
  //   path: "/summary",
  //   component: lazy(() => import("./views/CheckoutSummary")),
  // },
  // {
  //   exact: true,
  //   path: "/payment",
  //   component: lazy(() => import("./views/CheckoutPayment")),
  // },
  // {
  //   exact: true,
  //   path: "/review",
  //   component: lazy(() => import("./views/CheckoutReview")),
  // },
  // {
  //   exact: true,
  //   path: "/success",
  //   component: lazy(() => import("./views/CheckoutSuccess")),
  // },
  {
    exact: true,
    path: "/sell",
    component: lazy(() => import("./views/Sell")),
  },
  {
    exact: true,
    path: "/brief",
    component: lazy(() => import("./views/Brief")),
  },
  {
    exact: true,
    path: "/dashboard",
    component: lazy(() => import("./views/SellerAccount")),
  },
  {
    exact: true,
    path: "/verify_account/:verification_link",
    component: lazy(() => import("./views/VerifyAccount")),
  },
  // {
  //   exact: true,
  //   path: "/sell/:buy_id/:item_id/edit",
  //   component: lazy(() => import("./views/AddItem")),
  // },
  {
    exact: true,
    path: "/sale/:buy_id/offer",
    component: lazy(() => import("./views/Offer")),
  },
  {
    exact: true,
    path: "/payout",
    component: lazy(() => import("./views/Payment")),
  },
  {
    exact: true,
    path: "/submission_success",
    component: lazy(() => import("./views/Marketing")),
  },
  {
    exact: true,
    path: "/sale/:buy_id/offer_accepted",
    component: lazy(() => import("./views/PackAndShip")),
  },
  //this for consignment ask for what should be the flag
  {
    exact: true,
    path: "/sale/:buy_id/offer_accepted/sold",
    component: lazy(() => import("./views/PackAndShip")),
  },
  {
    exact: true,
    path: "/sale/:buy_id/view",
    component: lazy(() => import("./views/SubmissionPending")),
  },
  {
    exact: true,
    path: "/account/:form?",
    component: lazy(() => import("./views/Account")),
  },
  {
    exact: true,
    path: "/forgot_password",
    component: lazy(() => import("./views/ForgotPassword")),
  },
  {
    exact: true,
    path: "/change_password",
    component: lazy(() => import("./views/ChangePassword")),
  },
  {
    exact: true,
    path: "/contact_info",
    component: lazy(() => import("./views/ContactInfo")),
  },
  {
    exact: true,
    path: "/",
    component: () => <Redirect to = "/dashboard"/>,
  },
  // {
  //   exact: true,
  //   path: "/login",
  //   component: lazy(() => import("./views/Login")),
  // },
  // {
  //   exact: true,
  //   path: "/manageListings",
  //   component: lazy(() => import("./views/ManageListings")),
  // },
  // {
  //   exact: true,
  //   path: "/:urlFilter?",
  //   component: lazy(() => import("./views/Home")),
  // },
  // {
  //   exact: true,
  //   path: "/404",
  //   component: lazy(() => import("src/views/pages/Error404View")),
  // },
  {
    path: "*",
    //   layout: MainLayout,
    routes: [
      {
        component: () => <Redirect to="/404" />,
      },
    ],
  },
];

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </Layout>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
